import React from 'react';
import { observer } from 'mobx-react';
import TextField from '../inputs/textField';

import {
    SpaceBetweenDiv,
    TextTiny,
    FlexDiv,
    TextLead,
    Heading2,
    ThemedButton,
    palette,
    CheckboxInput,
    TextInput,
} from '@awarego-ui/components';
import { MenuItem } from '@mui/material';

function SimpleForm({ form, fullWidth }) {
    return (
        <FlexDiv column fullWidth>
            {form.map((field) => {
                if (field.type === 'checkbox') {
                    return <CheckboxInput key={field.name} {...field.bind()} />;
                } else if (field.type === 'select') {
                    return (
                        <TextInput
                            key={field.name}
                            select
                            margin={'dense'}
                            stretched
                            variant={'outlined'}
                            onChange={(e) => field.onChange(e.target.value)}
                            {...field.bind()}
                        >
                            {field.extra.map((t) => {
                                return (
                                    <MenuItem key={t.value} value={t.value}>
                                        {t.label}
                                    </MenuItem>
                                );
                            })}
                        </TextInput>
                    );
                } else
                    return (
                        <TextField
                            key={field.name}
                            field={field}
                            fullWidth={fullWidth}
                            minWidth={'350px'}
                        />
                    );
            })}
        </FlexDiv>
    );
}

export default observer(SimpleForm);
